import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "./ui/dialog";
import { Search } from "lucide-react";
import api, { inr } from "../lib/api";

export default function SearchDialog({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!q.trim()) {
      setResults([]);
      return;
    }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/products`, { params: { search: q, limit: 6 } });
        setResults(data);
      } catch (e) {}
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (slug) => {
    onOpenChange(false);
    setQ("");
    navigate(`/product/${slug}`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-0 gap-0 bg-ivory border-line top-24 translate-y-0" data-testid="search-dialog">
        <div className="flex items-center gap-3 border-b border-line px-6 py-5">
          <Search size={20} className="text-ink-soft" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search lehengas, sarees, occasions…"
            className="flex-1 bg-transparent text-lg outline-none placeholder:text-ink-soft/60 font-serif"
            data-testid="search-input"
          />
        </div>
        <div className="max-h-[50vh] overflow-y-auto">
          {q && results.length === 0 && (
            <p className="px-6 py-8 text-sm text-ink-soft">No pieces found for “{q}”.</p>
          )}
          {results.map((p) => (
            <button
              key={p.slug}
              onClick={() => go(p.slug)}
              className="flex w-full items-center gap-4 px-6 py-3 text-left hover:bg-black/[0.03] transition-colors"
              data-testid={`search-result-${p.slug}`}
            >
              <img src={p.primary_image} alt={p.name} className="h-16 w-12 object-cover bg-[#efece6]" />
              <div className="flex-1">
                <p className="font-serif text-lg leading-tight">{p.name}</p>
                <p className="overline text-gold-deep">{p.fabric}</p>
              </div>
              <span className="text-sm">{inr(p.price)}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
